import { ref, reactive } from 'vue';
const identity = ref('Admin');
const userData = reactive({
    userName: '',
    Email: ''
});
const server = {
    CHN: 'China Mainland',
    ASIA: 'Asia',
    USA: 'America',
    EUR: 'EMEA',
    JPN: 'Japan',
    INDIA: 'India',
    RU: 'Russia',
    INC: 'The Middle East',
    AUS: 'Oceania'
};
export default null;
export { identity, userData, server };
